import { toNumber } from './utils';

function PerguntaMetadados({ intl, pergunta }) {
  return (
    <div className="tw:text-xs tw:text-[#667085]">
      {toNumber(pergunta.totalRespostas)}{' '}
      {intl.formatMessage({ id: 'labelRespostas' })}
      {pergunta.totalSelecoes != null && (
        <>
          {' · '}
          {toNumber(pergunta.totalSelecoes)}{' '}
          {intl.formatMessage({ id: 'labelSelecoes' })}
        </>
      )}
      {pergunta.permitirComentario && (
        <>
          {' · '}
          {toNumber(pergunta.totalComentarios)}{' '}
          {intl.formatMessage({ id: 'labelComentarios' })}
        </>
      )}
    </div>
  );
}

export default PerguntaMetadados;
